'use client';

import { useDynamicContext } from '@dynamic-labs/sdk-react-core';
import Image from 'next/image';

import { tw } from '@repo/ui';
import { getImageUrl } from '@repo/utils';

import { useIsClaimEnded } from '@claim/hooks/use-claim-ended';
import { useIsPreClaimActive } from '@claim/hooks/use-pre-claim-active';

import { useIsClaimActive } from '../../hooks/use-claim-active';
import { ClaimButton } from '../button';

export const LoggedOut: React.FC = () => {
  const { setShowAuthFlow } = useDynamicContext();

  const isClaimActive = useIsClaimActive();
  const preClaimActive = useIsPreClaimActive();
  const isClaimEnded = useIsClaimEnded();

  return (
    <div
      className={tw(
        'relative z-10 mx-auto flex w-full max-w-6xl flex-col',
        'px-2 md:px-0',
        preClaimActive ? 'min-h-[90vh]' : 'min-h-screen',
      )}
    >
      <div
        className={tw(
          'mt-24 mb-16 flex w-full flex-col items-center md:mt-12 md:mb-4',
        )}
      >
        <div className='relative h-auto w-full'>
          <Image
            src={getImageUrl('/claim/images/main-dood.gif')}
            alt='Dood'
            layout='responsive'
            width={500}
            height={339}
            quality={100}
          />
        </div>
      </div>

      <div
        className={tw(
          'z-20 mt-[-5rem] flex flex-col items-center justify-end gap-7 text-white',
          'md:mt-[-8rem]',
        )}
      >
        <div
          className={tw(
            'mt-2',
            !preClaimActive && !isClaimEnded && 'w-[300px]',
          )}
        >
          {!preClaimActive && !isClaimEnded ? (
            <ClaimButton
              onClick={() => setShowAuthFlow(true)}
              text='CONNECT A WALLET'
              hasEnoughSol
              hasSolWallet
            />
          ) : isClaimEnded ? (
            <div className='flex flex-col items-center gap-2 text-center'>
              <p className='font-semibold'>THE $DOOD CLAIM PERIOD HAS ENDED.</p>
              <p className='max-w-[525px] font-light text-white/50'>
                The claiming period has officially wrapped up. But don't worry,
                the adventure in the Doodles universe is just getting started!
              </p>
              <a
                href='https://doodles.app'
                target='_blank'
                rel='noreferrer'
                className='mt-2 max-w-[300px]'
              >
                <ClaimButton
                  text='EXPLORE THE ECOSYSTEM'
                  hasEnoughSol
                  hasSolWallet
                />
              </a>
            </div>
          ) : (
            <div className='flex flex-col gap-1 text-center'>
              <p className='font-semibold'>
                PRE-REGISTRATION HAS ENDED. CLAIM BEGINS AT TGE.
              </p>
              <p className='font-light text-white/50'>
                Final allocations will change based on wallet contents up until
                airdrops begin processing.
              </p>
            </div>
          )}
        </div>

        <div className='flex flex-col gap-1'>
          {!preClaimActive && !isClaimEnded ? (
            <>
              <p className='text-center text-sm font-semibold md:text-base'>
                {isClaimActive
                  ? 'CONNECT A WALLET TO CHECK $DOOD CLAIM ELIGIBILITY'
                  : 'CONNECT A WALLET TO REGISTER FOR YOUR $DOOD AIRDROP'}
              </p>
              <p className='text-center text-sm font-thin opacity-50 md:text-base'>
                Don't worry, you can connect more wallets later.
              </p>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};
